module.exports = __webpack_public_path__ + "img/kh.b3dadd9.svg";